export enum FeatureListIconVariants {
  ThirdPartyLogo = 'ThirdPartyLogo',
  Icon = 'Icon',
}
